// import Echo from "laravel-echo";
// import Pusher from "pusher-js";
import TokenService from '@services/token.service';

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true,
//     auth: {
//         headers: {
//             Authorization: `Bearer ${TokenService.getToken()}`,
//         },
//     },
// });

// window.Echo.connector.pusher.connection.bind('connected', function () {
//     window.axios.defaults.headers.common['X-Socket-Id'] = window.Echo.socketId();
// });

/**
 * We will get the CSRF Token from meta tag in main page and register it as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

window.CSRFtoken = document.head.querySelector('meta[name="csrf-token"]').content;
if (!CSRFtoken) {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

    // Fix for Bootstrap modal recursion error when using 3rd party libs like flatpickr
    if ($.fn.modal) {
        $.fn.modal.Constructor.prototype._enforceFocus = function() {};
    }
} catch (e) { }